import React from 'react';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';

import loadable from '@loadable/component';
const PromosPanel = loadable(() =>
  import('components/components/organisms/PromosPanel'),
);

const PromosFlyout = ({ fields }) => {
  const cardsViewModel = getFieldValue(fields, 'cardsViewModel') || [];
  const title = getFieldValue(fields, 'title');
  const blueBackground = getFieldValue(fields, 'blueBackground');
  const communityStatus = getFieldValue(fields, 'communityStatus');

  if (
    communityStatus &&
    ['Closed', 'Closeout', 'Sold Out', 'Final Opportunities'].includes(
      communityStatus,
    )
  ) {
    return '';
  }

  return (
    <PromosPanel
      title={title}
      cards={cardsViewModel}
      blueBackground={blueBackground}
    />
  );
};

export default PromosFlyout;
